<div class="lab-order-manager-wrapper">

    <ispm-order-list [selectedOrder]="selectedOrder"
        [ngStyle]="{width: config?.listPanel?.width, display: config?.listPanel?.hidden == true ? 'none' : 'inherit'}"
        [orders]="orders" [loading]="loading" [config]="config" [biodesixOrderDetails]="biodesixOrderDetails$ | async"
        (onChangeOrder)="handleChangeSelectedOrder($event)" (onCreateOrder)="showCreateOrderPopup()"
        (onDeleteOrder)="deleteOrder($event)" [isEditable]="isEditable" [disableAddButton]="disableAddButton" [canDelete]="canDelete">
    </ispm-order-list>
    <div class="flex-right-col">
        <ispm-lab-order-content [ngStyle]="{width: config?.contentPanel?.width}" [selectedOrder]="selectedOrder"
            [config]="config" (onFormPartialSave)="partialSaveOrderContent($event)"
            [orderContentFormConfigs]="selectedOrderDefinition?.formsConfig"
            [selectedOrderDetails]="selectedOrderDetails"
            (onFormDataSave)="onSaveOrderContent($event)" [isEditable]="isEditable"
            [hasUpdatedFields]="hasUpdatedFields" [watchPropertyForSaveButton]="watchPropertyForSaveButton">
        </ispm-lab-order-content>

    </div>
    <gen-dynamic-modal-loader class="pan-cancer-event-modal" [observableName]="ModalLoaderTunnelName">
    </gen-dynamic-modal-loader>
</div>
